'use es6';

import PropTypes from 'prop-types';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { FormControl } from 'foundations-components/transitional/components/FormControl';
import { TextInput } from 'foundations-components/transitional/components/TextInput';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const FolderNavCreateFolderBody = ({
  folderName,
  onFolderNameChange
}) => /*#__PURE__*/_jsxs("div", {
  children: [/*#__PURE__*/_jsx("strong", {
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "salesContentIndexUI.folderModal.create.createNewFolder"
    })
  }), /*#__PURE__*/_jsx(FormControl, {
    label: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "salesContentIndexUI.folderModal.create.folderName"
    }),
    children: /*#__PURE__*/_jsx(TextInput, {
      name: "folder-name",
      value: folderName,
      onChange: e => onFolderNameChange(e.target.value)
    })
  })]
});
FolderNavCreateFolderBody.propTypes = {
  folderName: PropTypes.string.isRequired,
  onFolderNameChange: PropTypes.func.isRequired
};
export default FolderNavCreateFolderBody;